import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9839bd8a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "IDESideBarContentTabSettings" }
const _hoisted_2 = { class: "group" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Textový editor", -1))
const _hoisted_4 = { class: "settings" }
const _hoisted_5 = { class: "item" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "fontSizeSlider" }, "Velikost písma", -1))
const _hoisted_7 = { class: "value" }
const _hoisted_8 = { class: "fontSizeGroup" }
const _hoisted_9 = { class: "item" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "wordWrap" }, "Zalamování řádek", -1))
const _hoisted_11 = { class: "value" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "wordWrap",
  class: "toggler-wrapper"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "toggler-slider" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "toggler-knob" })
  ])
], -1))

import { ref, withDefaults, watch, onMounted } from 'vue';

export interface PropsOptions {
	settings: Settings,
}

export interface Settings {
	fontSize?: number,
	wordWrap?: boolean,
	sideBarContentShown?: boolean,
}

export const EmitsOptions = {
	'onSettingsChanged' : (settings: Settings) => {return true;},
}

export default /*#__PURE__*/_defineComponent({
  __name: 'IDESideBarContentTabSettings',
  props: {
    settings: null
  },
  emits: EmitsOptions,
  setup(__props: any, { emit }) {

const props = __props as { settings: Settings }






const inputFontSizeSlider = ref("");
const inputFontSizeTextValue = ref("");
const inputWordWrap = ref(false);

function isNumeric(value:string) {
	return /^-?\d+$/.test(value);
}

function applySettingsToForm() {
	inputFontSizeSlider.value = `${props.settings.fontSize}`;
	inputFontSizeTextValue.value = `${props.settings.fontSize}`;
	inputWordWrap.value = props.settings.wordWrap !== undefined ? props.settings.wordWrap : false;
}
onMounted(() => {
	applySettingsToForm();
});


function setSettingsFontSize(size:number) {
	if (size >= 8 && size <= 40) {
		if (props.settings.fontSize != size) {
			emit('onSettingsChanged', {
				fontSize: size,
			});
		}
	}
}
watch(() => inputFontSizeSlider.value, (value, oldValue) => {
	if (value.length == 0 || !isNumeric(value)) {
		// neplatny
	}else {
		// ok
		setSettingsFontSize(+value);
	}
});
watch(() => inputFontSizeTextValue.value, (value, oldValue) => {
	if (value.length == 0 || !isNumeric(value)) {
		// neplatny
	}else {
		// ok
		setSettingsFontSize(+value);
	}
});

watch(() => inputWordWrap.value, (value, oldValue) => {
	if (props.settings.wordWrap != value) {
		emit('onSettingsChanged', {
			wordWrap: value,
		});
	}
});

// sledovat zmenu nastaveni settings a podle toho upravit formular
watch(props.settings, (value, oldValue) => {
	applySettingsToForm();
}, {deep: true});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _withDirectives(_createElementVNode("input", {
                type: "range",
                id: "fontSizeSlider",
                min: "6",
                max: "40",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inputFontSizeSlider).value = $event))
              }, null, 512), [
                [_vModelText, inputFontSizeSlider.value]
              ]),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                id: "fontSizeTextValue",
                size: "2",
                maxlength: "2",
                style: {"width":"2em"},
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((inputFontSizeTextValue).value = $event))
              }, null, 512), [
                [_vModelText, inputFontSizeTextValue.value]
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              id: "wordWrap",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((inputWordWrap).value = $event))
            }, null, 512), [
              [_vModelCheckbox, inputWordWrap.value]
            ]),
            _hoisted_12
          ])
        ])
      ])
    ])
  ]))
}
}

})